import { Component, HostListener, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Location, DOCUMENT, isPlatformBrowser } from "@angular/common";
import { Meta, Title } from '@angular/platform-browser';
import { DESCIPTION_BASE, TITLE } from './news-eng/constant/app-constant'
import { Renderer2 } from '@angular/core';
import { FRONT_URL } from "./news-eng/constant/app-constant";
import { MatDialog } from '@angular/material/dialog';
interface Food {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  selectHome = true
  routerPath = 'home';
  showFiller = false;
  value: number = 0;
  selectedLang = 'eng'
  base_url = FRONT_URL
  constructor(private renderer2: Renderer2, @Inject(DOCUMENT) private document: Document, public dialog: MatDialog) {

  }

  ngOnInit() {
    // const s = this.renderer2.createElement('script');
    // s.type = 'text/javascript';
    // s.src = 'https://tags.adstudio.cloud/newsfirst.js';
    // this.renderer2.appendChild(this.document.body, s);

  }

}
